import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-topup-page',
  templateUrl: './topup-page.component.html',
  styleUrls: ['./topup-page.component.css']
})
export class TopupPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
